import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { isObservable, Observable, of } from 'rxjs';
import { ElenchiService } from 'app/services/elenchi.service';
import { isArray } from 'lodash-es';

interface InputProps extends FormlyFieldProps {
    options_type:string
}

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'select-read' | Type<SelectReadType>;
}
@Component({
  selector: 'select-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `
    <div class= "">
        <p>{{ label$ | async }}</p>
    </div>
  `,
  imports:[AsyncPipe]
})
export class SelectReadType extends FieldType<FieldTypeConfig<InputProps>>{

    label$:Observable<string>
    private _elenchiService = inject(ElenchiService)

    ngOnInit(){
        const value = this.formControl.value

        if (isObservable(this.props.options)){
            this.label$ = this._elenchiService.getLabelOption(this.field.props.options_type, value)
        }
        else if (isArray(this.props.options)){
            const res = this.props.options.filter((x: any) => String(x.value) == String(value));
            if (res.length>0){
                this.label$=of(res[0]?.label)
            }
            else{
                return of(value)
            }
        }
        else{
            return of(value)
        }

    }

}
